<template>
    <div id="app">
        <Paylist :Type="AppServiceID" />
    </div>
</template>

<script>
import Vue from 'vue';
import Paylist from '@/components/Common/Paylist.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

  data: function (){
        return {
        AppServiceID :'',
        }
    },
    components: {
        Paylist
    },
    created: function() {
        this.AppServiceID = this.$store.getters.GetOpticalID;
        this.$emit('update:layout', LayoutDefault);
    },    
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetOpticalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetOpticalID);
    },

}
</script>

<style>

</style>

